module.exports = __webpack_public_path__ + "static/media/2 3 tattoo arm lioness safari savanna acacia realism.1280x1707.d968d739.webp";